import httpClient from "../../../shared/api/httpClient";
import { qs } from "../../../shared/api/qs";

export function getGlobalIngredientCatalog({ page = 1, limit = 25, name, category, sector, isActive, signal } = {}) {
  const query = qs({ page, limit, name, category, sector, isActive });
  return httpClient.get(`/stock/ingredient-catalog/global${query}`, { signal });
}

export function getGlobalIngredientCategories({ signal } = {}) {
  return httpClient.get("/stock/ingredient-catalog/global/categories", { signal });
}

export function createGlobalIngredient(data) {
  return httpClient.post("/stock/ingredient-catalog/global", data);
}

export function updateGlobalIngredient(catalogItemId, data) {
  return httpClient.patch(`/stock/ingredient-catalog/global/${catalogItemId}`, data);
}

export function deactivateGlobalIngredient(catalogItemId) {
  return httpClient.delete(`/stock/ingredient-catalog/global/${catalogItemId}`);
}
